import { useCallback } from 'react';
import { AppActionPostRequestResponseHandler, AppActionsPostResponse } from '../components/AppDetails/AppActions/types';
import { decodeHTMLEntities } from '../utils/helpers';
import { NotificationData, NotificationVariant } from '../components/Common/Notifications/types';
import { showHideGlobalNotification } from '../redux/reducers/app-market-slice';
import { useAppDispatch } from './reduxHooks';
import { isLaunchUrlPathAvailable, getLaunchUrlPathOrNull } from '../component-helpers/app-actions';
import { RTKQueryResponseType } from "../redux/api/appMarket-api-slice";
import { App } from "../models/app";

export const useHandlePostRequestResponse = () : AppActionPostRequestResponseHandler => {
  const reduxDispatch = useAppDispatch();

  const showNotification = useCallback((notification: NotificationData): void => {
    reduxDispatch(showHideGlobalNotification({
      notificationData: notification,
      notificationProperties: {
        fixedPosition: true,
        closeable: true
      }
    }));
  }, [reduxDispatch]);

  const showSuccessBanner = useCallback(
    (notification?: NotificationData): void => {
      showNotification(notification || {
        variant: NotificationVariant.Green,
        title: 'app_actions.banners.success_generic',
      });
    }, [showNotification],
  );

  const throwFailedRequestBanner = useCallback(
    (): void => {
      showNotification({
        variant: NotificationVariant.Yellow,
        title: 'app_actions.banners.failed_request',
      });
    }, [showNotification],
  );

  const openApp = (
      reqResponse: RTKQueryResponseType<AppActionsPostResponse>,
      app?: App
  ) => {
    if ('data' in reqResponse && reqResponse.data && 'redirectUrl' in reqResponse.data && reqResponse.data.redirectUrl) {
      if(!!app && isLaunchUrlPathAvailable(app)) {
        window.open(decodeHTMLEntities(getLaunchUrlPathOrNull(app)), '_blank');
      } else {
        window.open(decodeHTMLEntities(reqResponse.data.redirectUrl), '_blank');
      }
    }
  }
  return useCallback<AppActionPostRequestResponseHandler>(({
    reqResponse,
    successNotification,
    stopSuccessNotification,
    app
  }) => {
    if (!reqResponse) {
      return;
    }
    if ('data' in reqResponse && reqResponse.data) {
      if (!stopSuccessNotification) {
        showSuccessBanner(successNotification);
      }
      openApp(reqResponse, app)
    } else if ('error' in reqResponse && typeof reqResponse.error === 'string') {
      showNotification({
        variant: NotificationVariant.Yellow,
        title: reqResponse.error.includes('Content cannot contain profanity')
            ? 'app_actions.banners.inappropriate_language'
            : 'app_actions.banners.error_loading',
      });
    } else {
      throwFailedRequestBanner();
    }
  }, [showSuccessBanner, throwFailedRequestBanner, showNotification]);
};
